import config from '@config';

import APIClient from './apiClient';

export const client = new APIClient(config.INSURANCE_API);
